<template> 
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <div 
      class="mt-3 background-default pa-7">
      <div>
        <div class="title text--secondary mb-5">
          Tambah Admin
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
              <v-text-field
                outlined
                dense
                color="#ff618a"
                label="Nama"
                v-model="form.name"
                :error-messages="errors"
                required>
              </v-text-field>
            </ValidationProvider>
            <v-row>
              <v-col cols="12" md="6" v-if="$route.query.id === undefined">
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <v-text-field
                    outlined
                    dense
                    color="#ff618a"
                    label="Email"
                    v-model="form.email"
                    :error-messages="errors"
                    required>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" :md="$route.query.id === undefined ? '6' : '12'">
                <ValidationProvider name="Telepon" rules="required|min:8|max:13" v-slot="{ errors }">
                  <v-text-field
                    type="number"
                    outlined
                    dense
                    color="#ff618a"
                    label="Telepon"
                    v-model="form.phoneNumber"
                    :error-messages="errors"
                    required>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <p class="mb-1">Deskripsi (optional)</p>
            <quill-editor 
              ref="myTextEditor" 
              v-model="form.desc"
              :options="option">
            </quill-editor>
            <p class="mb-1 mt-5">Gambar Profil (optional)</p>
            <v-card
              flat
              width="200"
              class="pa-0 mt-3"
              style="background: transparent;">
              <image-input v-model="avatar">
                <div slot="activator">
                  <v-avatar 
                    width="200"
                    height="200"
                    v-ripple 
                    tile
                    class="grey lighten-3 c-p">
                    <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                    <div class="px-5" v-if="addImage && avatar.url === undefined">
                      <v-progress-linear
                        color="#ff618a"
                        indeterminate
                        rounded
                        height="6"
                        class="mx-4 mt-4"
                        style="width: 80px;">
                      </v-progress-linear>
                      <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                        Mengupload Gambar . . .
                      </p>
                    </div>
                    <v-img v-if="avatar && !addImage"
                      :src="form.urlImg"
                      width="200"
                      height="200">
                    </v-img>
                  </v-avatar>
                </div>
              </image-input>
            </v-card>
            <p class="subtitle-2 mb-2 mt-6">
              Pilih Menu
            </p>
            <v-divider class="mb-2"/>
            <v-row justify="center">
              <v-col cols="3" v-if="process.run">
                <div 
                  class="text-center mt-12 mb-12">
                  <p class="title color-default mt-8 mb-5">
                    Menunggu data . . .
                  </p>
                  <v-progress-linear
                    color="#ff618a"
                    indeterminate
                    rounded
                    height="6">
                  </v-progress-linear>
                </div>
              </v-col>
              <v-col cols="12" v-else>
                <v-list
                  color="transparent"
                  dense
                  nav
                  v-for="(item, index) in menu"
                  :key="index"
                  class="py-0">
                  <v-list-item
                    :value="true">
                    <v-list-item-icon class="mr-3">
                      <v-icon>{{ item.menuIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.menuTitle }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption font-weight-light font-italic">
                        {{ item.menuUrl }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content class="ml-3 d-flex justify-end">
                      <v-checkbox 
                        color="#ff618a"
                        :hide-details="true"
                        class="mt-0"
                        :value="item.id"
                        v-model="selected.parent">
                      </v-checkbox>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :v-if="item.menuSubmenu.length > 0"
                    v-for="(sub, index) in item.submenuDetail"
                    :key="index"
                    class="pl-10">
                    <v-list-item-icon class="mr-3">
                      <v-icon>{{ sub.submenuIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ sub.submenuTitle }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption font-weight-light font-italic">
                        {{ sub.submenuUrl }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <!-- <v-list-item-content class="ml-3 d-flex justify-end">
                      <v-checkbox 
                        color="#ff618a"
                        :hide-details="true"
                        class="mt-0"
                        :value="sub"
                        v-model="selected.child">
                      </v-checkbox>
                    </v-list-item-content> -->
                  </v-list-item>
                  <!-- <v-list-item
                    v-if="item.menuSubmenu.length < 1"
                    :value="true">
                    <v-list-item-icon class="mr-3">
                      <v-icon>{{ item.menuIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.menuTitle }}</v-list-item-title>
                      <v-list-item-subtitle class="caption font-weight-light font-italic">{{ item.menuUrl }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content class="ml-3 d-flex justify-end">
                      <v-checkbox 
                        color="#ff618a"
                        :hide-details="true"
                        class="mt-0"
                        :value="item"
                        v-model="selected.parent">
                      </v-checkbox>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-group
                    class="mr-2"
                    no-action
                    multiple
                    v-if="item.menuSubmenu.length > 0"
                    color="#494949"
                    :value="false">
                    <template v-slot:activator>
                      <v-list-item-icon class="mr-3">
                        <v-icon>{{ item.menuIcon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.menuTitle }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="caption font-weight-light font-italic">
                          {{ item.menuUrl }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox 
                          color="#ff618a"
                          :hide-details="true"
                          class="mt-0"
                          :value="item"
                          v-model="selected.parent">
                        </v-checkbox>
                      </v-list-item-action>
                    </template>
                    <v-list-item
                      v-for="(sub, index) in item.submenuDetail"
                      :key="index"
                      class="pl-7">
                      <v-list-item-icon class="mr-3">
                        <v-icon>{{ sub.submenuIcon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ sub.submenuTitle }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="caption font-weight-light font-italic">
                          {{ sub.submenuUrl }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content class="ml-3 d-flex justify-end">
                        <v-checkbox 
                          color="#ff618a"
                          :hide-details="true"
                          class="mt-0"
                          :value="sub"
                          v-model="selected.child">
                        </v-checkbox>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group> -->
                </v-list>
              </v-col>
            </v-row>
            <div>
              <v-alert 
                type="error" 
                text
                dense
                prominent
                v-show="response !== ''">
                {{ response }}
              </v-alert>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                color="#ff618a"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-btn
                rounded
                :width="$vuetify.breakpoint.name === 'lg' ? '200' : '100'"
                elevation="0"
                outlined
                class="text-capitalize"
                :disabled="process.form"
                to="/admin">
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from '../../../components/ImageInput.vue';
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        selected: {
          parent: [],
          child: []
        },
        menu: [],
        addImage:'',
        detail: {},
        avatar: null,
        form: {
          name : "",
          email : "",
          password : "12345",
          passwordConfirm : "12345",
          phoneNumber: "",
          desc : "",
          urlImg : "",
          role : "admin"
        },
        process: {
          form: false,
          run: false
        },
        response: ''
      }
    },
    watch:{
      avatar: {
        handler: function () {
          this.form.urlImg = this.avatar.url
          this.addImage = this.avatar.add
        },
        deep: true
      },
    },
    components: {
      ImageInput
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
      if (this.$route.query.id !== undefined) {
        this.fetchDetail()
      }
    },   
    methods: { 
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/internal/menu/list`, {
          params: {
            limit: 100
          }
        }).then((response) => {
          let res = response.data;
          if (res.code === 200) {
            this.process.run = false;
            this.menu = res.data
          }
        })
      },
      async fetchDetail() {
        await get(`api/internal/users/detail/${this.$route.query.id}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.detail = response.data.data
            this.reset()
          }
        })
      },
      reset (id, page) {
        this.avatar = {
          url: this.detail.userUrlImg
        }

        this.form= {
          name : this.detail.userFullname,
          email : this.detail.userEmail,
          password : "12345",
          passwordConfirm : "12345",
          phoneNumber: this.detail.userPhoneNumber,
          desc : this.detail.userDesc.replace(/&lt;/g, '<'),
          urlImg : this.detail.userUrlImg,
          role : "admin"
        }
        this.selected.parent = this.detail.userPrivilege
      },
      changeMenu(item) {
        this.selected.parent.push(item)
        this.selected.parent.concat(this.selected.parent)
      },
      async save() {
        this.response = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          if (this.$route.query.id !== undefined) {
            this.updates()
          } else {
            this.creates()
          }
        }
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/users/create`, {
          data: {
            email: this.form.email,
            password: this.form.password,
            passwordConfirm: this.form.passwordConfirm,
            phoneNumber: this.form.phoneNumber,
            fullName: this.form.name,
            desc: this.form.desc,
            urlImg: this.form.urlImg,
            role: this.form.role,
            privilege: this.selected.parent
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            window.location = `/admin`
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/users/update/${this.$route.query.id}`, {
          data: {
            phoneNumber: this.form.phoneNumber,
            fullName: this.form.name,
            desc: this.form.desc,
            urlImg: this.form.urlImg,
            role:'admin',
            privilege:this.selected.parent
          }
        }).then(response => {
          let res = response.data
          if (res.code === 201) {
            window.location = `/admin`
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  }
</script>